import { ContextMenuState } from "../ContextMenuState";

import { BfxBlotterOrdersContextMenuAcceptanceItem as AcceptanceItem } from "./BfxBlotterOrdersContextMenuAcceptanceItem";
import { BfxBlotterOrdersContextMenuAcceptanceState as AcceptanceState } from "./BfxBlotterOrdersContextMenuAcceptanceState";
import { BfxBlotterOrdersContextMenuRejectItem as RejectItem } from "./BfxBlotterOrdersContextMenuRejectItem";
import { BfxBlotterOrdersContextMenuRejectState as RejectState } from "./BfxBlotterOrdersContextMenuRejectState";
import { ActiveUser } from "../../core/ActiveUser";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { PricingService } from "shared/cubiq-services/lookup/pricing/PricingService";

export class BfxBlotterOrdersContextMenuState extends ContextMenuState {
  public canStealFromManual: boolean;
  public canStealFromAuto: boolean;
  public canForceSteal: boolean;
  public canTransferUnrestricted: boolean;
  public canTransfer: boolean;
  public canTransferAccept: boolean;
  public canAbortExternalTransfer: boolean = false;
  public canUnlock: any;
  public canCancel: boolean;
  public canCancelCrossClient: boolean;
  public canCancelHedge: boolean;
  public canUnrestrictedCancelModify: boolean;
  public canModify: boolean;
  public canModifyTriggered: boolean;
  public canReactivateOrders: boolean;
  public canFillOrders: boolean;
  public canQuickFillOrders: boolean;
  public canFillNow: boolean;
  public canEnterOrders: boolean;
  public canViewOrderEntry: boolean;
  public canEnterOrdersUnrestricted: boolean;
  public slQuickFillEnabled: string;
  public canAccept: boolean;
  public canReject: boolean;
  public canAcceptUnrestricted: boolean;
  public canAmendMarkup: boolean;
  public canPauseResume: boolean;
  public canExportForImport: boolean;
  public canChangeInflightStatus: boolean;
  public canViewTicket: boolean;

  public canDIApproveFill: boolean;
  public canDICancelFill: boolean;

  public acceptance: AcceptanceState = AcceptanceItem.state;
  public reject: RejectState = RejectItem.state;
  public sysConfigCommentsPrivatePrivatized: boolean;
  public sysConfigCommentsPrivateEnabled: boolean;
  public sysConfigCommentsClientPrivatized: boolean;
  public activeUser: ActiveUser = new ActiveUser();
  public traderGroups: Map<string, CubiqTS.TradingGroupImpl> = new Map();
  //transient field
  public pricingService: PricingService;

  public canExport: boolean;

  constructor() {
    super();
  }

  public reset(): void {
    super.reset();
    this.acceptance = AcceptanceItem.state;
    this.reject = RejectItem.state;
  }
}
